<template>
  <div id="app">
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Mutabakat Mektubu</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
            <v-menu offset-y>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>

                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title>Html İndir</v-list-tile-title>
                </v-list-tile>


                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title>Excel İndir</v-list-tile-title>
                </v-list-tile>

              </v-list>
            </v-menu>

          </v-toolbar>
        </v-flex>



        <v-container fluid>
          <v-card color="grey lighten-5" flat>
               <v-form ref="formtarih" v-model="valid" lazy-validation>

            <v-layout row wrap>
              <v-flex xs12 sm6 md2>
                 <tarihcomp :etiket="'Gidiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="Mutabakat.Tarih" v-model="Mutabakat.Tarih"></tarihcomp>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-autocomplete label="Başlangıç Cari Seçiniz" hide-details clearable :loading="loading1" append-icon="search"
                  :items="statecari" item-text="text" :rules="[v => !!v || 'Lütfen cari seçiniz']" cache-items="" item-value="id" v-model="Mutabakat.BaslangicCari"
                  :search-input.sync="search"></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-autocomplete label="Bitiş Cari Seçiniz" clearable hide-details :loading="loading2" append-icon="search"
                  :items="statecari2" item-text="text" cache-items="" :rules="[v => !!v || 'Lütfen cari seçiniz']" item-value="id" v-model="Mutabakat.BitisCari"
                  :search-input.sync="search1"></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-checkbox v-model="Mutabakat.SifirBakiye" label="Sıfır Bakiye Verenleri Gösterme"></v-checkbox>
              </v-flex>
              <v-flex>
                <v-layout>
                  <div v-if="load1">
                    <v-btn color="info" @click="getList()" fab small="" dark>
                      <v-icon>search</v-icon>
                    </v-btn>
                  </div>
                  <div v-if="!load1">
                    <v-layout fill-height="" justify-center="" align-center="">
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-layout>
                  </div>

                  <!-- <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                    color="info" fab dark>
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-tooltip bottom="" :activator="el" v-model="tooltip">
                    <span>Arama Filtresi Ekle</span>
                  </v-tooltip> -->
                </v-layout>
              </v-flex>



              <v-flex xs12 sm12 md12>
                <v-card>
                  <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                    :search="search3">
                    <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
                        <td class="text-xs-center">{{ props.item.Cari.Unvan }}</td>
                        <td class="text-xs-right">{{ props.item.Tutar | moneyformat }}</td>
                        <td class="text-xs-center">{{ props.item.BA }}</td>
                        <v-btn icon class="mx-0" @click="mektupGetir(props.item)">
                          <v-icon color="green">email</v-icon>
                        </v-btn>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                    </v-alert>
                  </v-data-table>
                </v-card>
                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                  :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                  {{ text1 }}
                  <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                </v-snackbar>
              </v-flex>
            </v-layout>
            </v-form>
          </v-card>
        </v-container>

      </v-layout>
    </v-card>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
    import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    data() {
      return {
        search: '',
        headers: [{
            text: 'Cari Hesap Kodu',
            value: 'Cari.Kod'
          },
          {
            text: 'Ünvan ',
            value: 'Cari.Unvan',
            align: 'center'
          },
          {
            text: 'Tutar',
            value: 'Tutar',
            align: 'right'
          },
          {
            text: 'B/A',
            value: 'BA',
            align: 'center'
          }
        ],
valid:true,
        Mutabakat: {
          SirketKodu: null,
          Tarih: getDateNow(),
          BaslangicCari: null,
          BitisCari: null,
          OzetMutabakat: null,
          SifirBakiye: false
        },

        tumsirketler: '',

        grandDebt: 0,
        dueDebt: 0,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        loading1: false,
        loading2: false,
        loading3: false,
        statecari: [],
        statecari2: [],
        items: [],
        search1: '',
        search3: '',
        load: false,
        load1: true,
        butondurum: true,



        dialogfiltre: false,
        hesapkodu: [],
        Referans: [],
        masrafmerkezi: [],
        anahesap: [],
        renk1: 'info',
        a: '',
        b: '',
        c: '',
        d: '',
        progress: false,


        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
        dictionary: {
          custom: {

            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },
      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      // this.el = this.$refs.fab.$el

    },

    watch: {
      search(val) {
        val && this.carigetir(val)
      },
      search1(val2) {
        val2 && this.carigetir1(val2)
      }

    },
         filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
      carigetir: carigetir,
      carigetir1: carigetir1,
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      mektupGetir: mektupGetir
    }
  }




  function onChangecheck(elem1, elem2) {

    if (this.a === true && elem2 == 'a') {
      this.b = karsidegeral(this.a)
    }

    if (this.b === true && elem2 == 'b') {
      this.a = karsidegeral(this.b)
    }
  }



  function filtrele() {

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.Borc.Referans = null


    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })
    this.Borc.Masraf = null


  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false


  }

  function mektupGetir(v) {

              if (this.$refs.formtarih.validate()) {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.Mutabakat.BaslangicCari = v.Cari.Kod;
    this.Mutabakat.BitisCari = v.Cari.Kod;

    if (this.tumsirketler === true) {
      this.Mutabakat.SirketKodu = '0'
    } else {
      this.Mutabakat.SirketKodu = credentials.SirketKodu
    }

    var params = this.Mutabakat;
    this.$http.post(auth.API_URL + 'api/Report/CompromiseReportHtml', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {


      var blob = new Blob([response.data], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "MutabakatMektubu.html";
      link.click();
      this.progress = false
      this.load1 = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      }
    })

              }

  }

  function getList() {
    this.$validator.validateAll().then((result) => {

      if (result) {

      }

    })

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.Mutabakat.SirketKodu = '0'
    } else {
      this.Mutabakat.SirketKodu = credentials.SirketKodu
    }

    var params = this.Mutabakat;
    this.$http.post(auth.API_URL + 'api/Report/CompromiseReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body

      this.progress = false
      this.load1 = true


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      }
    })



  }


  function getListHtml() {
    this.progress = true
    this.grandDebt = 0
    this.dueDebt = 0


    if (this.date == null) {
      this.date = getDateNow()
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.Borc.SirketKodu = '0'
    } else {
      this.Borc.SirketKodu = credentials.SirketKodu
    }

    this.Borc.Tarih = this.date

    if (this.a === true) {
      this.Borc.Sira = '0'
    } else if (this.b === true) {
      this.Borc.Sira = '1'
    }

    var params = this.Borc

    this.load1 = false
    this.$http
      .post(auth.API_URL + "api/Report/DebitorListHtml", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/html'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "BorcluListesi.html";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false


        }
      })
  }

  function getListExcel() {
    this.progress = true
    this.grandDebt = 0
    this.dueDebt = 0


    if (this.date == null) {
      this.date = getDateNow()
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {
      this.Borc.SirketKodu = '0'
    } else {
      this.Borc.SirketKodu = credentials.SirketKodu
    }

    this.Borc.Tarih = this.date

    if (this.a === true) {
      this.Borc.Sira = '0'
    } else if (this.b === true) {
      this.Borc.Sira = '1'
    }

    var params = this.Borc

    this.load1 = false
    this.$http
      .post(auth.API_URL + "api/Report/DebitorListExcel", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then((response) => {
        this.progress = false
        this.load1 = true
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "BorcluListesi.xlsx";
        link.click();
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false


        }
      })
  }

  function beforeMount() {
    this.progress = true
    this.load1 = false
    this.Mutabakat.Tarih = getDateNow()

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params = this.Mutabakat;
    this.$http.post(auth.API_URL + 'api/Report/CompromiseReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body

      this.progress = false
      this.load1 = true


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.progress = false
        this.load1 = true

      }
    })
  }

  function carigetir(v) {
    if (v.length >= 0) {
      this.loading1 = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading1 = false
      }, 500)
    }
  }

  function carigetir1(v) {
    if (v.length >= 0) {
      this.loading2 = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari2 = response.body
        }, (response) => {
          if (response.status === 0) {
            this.Success = false
            this.Error = 'Service Unavailable'
          } else {
            this.Success = false
            this.Error = response.statusText
          }
        })
        this.loading2 = false
      }, 500)
    }
  }




  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }


  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }
</script>
<style>
  /* @import '../../../assets/css/custom.css'; */
</style>